exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/fyd0pik.css);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, ".button {\r\n  display: block;\r\n  background-color: #ffffff;\r\n  border: none;\r\n  font-size: 18px;\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  margin: 0 auto;\r\n  color: #000000;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  box-shadow: 0 0 5px #3a3a3a;\r\n  letter-spacing: 0.5px;\r\n  font-family: Open Sans, sans-serif; }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Button/Button.css
// module id = 789
// module chunks = 0